import { Box, Button, FormControlLabel, IconButton, MenuItem, Popover, Radio, RadioGroup, Select, Typography } from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from '@mui/styles';
import BoxMedia from "../../items/fragments/BoxMedia.js";
import BarChart from "../../items/fragments/BarChart.js";
import EntrySelect from "../../items/fragments/EntrySelect.js";

const MediaQuizz = ({item, match, onTagClick}) => {

    const {_id, creation, question, choices, nbVotes, options} = item
    const {validate, numberOfChoices} = options

    if(!choices || !choices[0])
      return ''

    if(choices[0] && choices[0].entries.length === 1)
      return (
          <BoxMedia media={item} match={match} onTagClick={onTagClick}>
            <Typography variant="mediaH2" component="div" sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}>{question}</Typography>

            <SingleQuestionQuizz quizz={item}/>
          </BoxMedia>
        );

    if(choices[0] && choices[0].entries.length > 1)
      return (
        <BoxMedia media={item} match={match} onTagClick={onTagClick}>
            <Typography variant="mediaH2" component="div" sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}>{question}</Typography>
            <MultipleQuestionQuizz quizz={item} />
          </BoxMedia>
        );
}

const SingleQuestionQuizz = ({ quizz, isSelectedChoice, handleVote }) => {
  const { _id, creation, question, choices, nbVotes, options } = quizz;
  const {validate, numberOfChoices } = options

  const useStyles = makeStyles((theme) => ({
    choiceContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '6px',
      borderRadius: '15px',
      maxWidth: '800px',
      border: `1px solid ${theme.palette.media.lightgrey}`,
      position: 'relative',
    },
    selectedChoice: {
      border: `1px solid ${theme.palette.media.darkblue}`,
    },
    correctChoice: {
      border: `1px solid ${theme.palette.media.green}`,
      color: theme.palette.media.green,
    },
    incorrectChoice: {
      border: `1px solid ${theme.palette.media.red}`,
      color: theme.palette.media.red,
    },
    disabledRadio: {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    enabledRadio: {},
    checkIcon: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translate(50%, -50%)',
      fontSize: '24px',
      backgroundColor: '#FFFFFF',
      padding: '4px',
      borderRadius: '50%',
    },
  }));

  const classes = useStyles();

    return (
      <>
      <Box className='medium-padding' sx={{  }}>
        <RadioGroup name={_id}>
          {choices.map((choice, idx) => (
            <Box
              key={idx}
              className={`${classes.choiceContainer}`}
            >
              <FormControlLabel
                value={choice.entries[0].id}
                sx={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }}
                control={
                  <Radio
                    color='quizzdarkblue'
                    style={{ marginRight: '8px' }}
                  />
                }
                label={choice.entries[0].name}
                className={classes.enabledRadio}
              />
            </Box>
          ))}
        </RadioGroup>
      </Box>

      {validate && <ValidateButton numberOfChoices={numberOfChoices}/>}
      </>
    );
};

const MultipleQuestionQuizz = ({ quizz, handleVote }) => {

  const { _id, creation, question, choices, nbVotes, options } = quizz;
  const { validate, numberOfChoices } = options

  const isCorrectAnswer = (choice, entryIdx) => choice.entries[entryIdx].isCorrect;

  const useStyles = makeStyles((theme) => ({
    choiceContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '6px',
      borderRadius: '15px',
      maxWidth: '800px',
      border: `1px solid ${theme.palette.media.lightgrey}`,
      position: 'relative',
    },
    selectedChoice: {
      border: `1px solid ${theme.palette.media.darkblue}`,
    },
    correctChoice: {
      border: `1px solid ${theme.palette.media.green}`,
      color: theme.palette.media.green,
    },
    incorrectChoice: {
      border: `1px solid ${theme.palette.media.red}`,
      color: theme.palette.media.red,
    },
    disabledRadio: {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    enabledRadio: {},
    checkIcon: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translate(50%, -50%)',
      fontSize: '24px',
      backgroundColor: '#FFFFFF',
      padding: '4px',
      borderRadius: '50%',
    },
  }));

  const classes = useStyles();

    return <>
            <Box
            className='medium-padding'
              sx={{
              }}
            >
                  {choices.map((choice, idx) => (
                      <Box mb={3} sx={{display : 'flex', maxWidth : '800px'}} key={idx}>
                          <EntrySelect choice={choice}/>
                      </Box>
                      
                  ))}
            </Box>
            {validate && <ValidateButton numberOfChoices={numberOfChoices} />}
    </>

}

const ValidateButton = ( {numberOfChoices}) => {

  return <Button variant="contained" color="primary" disabled={true}>{numberOfChoices > 1 ? 'Valider mes réponses' : 'Valider ma réponse'}</Button>
}

export default MediaQuizz